import * as React from 'react';

const RotateImageError: React.FunctionComponent = () => (
  <div>An error occurred during image rotation.</div>
);

export default RotateImageError;
